import type { WorkflowState } from '../state';

export function setCheckoutWorkflowData(
  state: WorkflowState,
  action: {
    payload: WorkflowState['locking'];
  },
) {
  state.locking.isLocked = action.payload.isLocked;
  state.locking.isLoggedInAgentOwner = action.payload.isLoggedInAgentOwner;
  state.locking.ownerEmail = action.payload.ownerEmail;
  state.locking.ownerFirstName = action.payload.ownerFirstName;
  state.locking.ownerLastName = action.payload.ownerLastName;
}
